import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export const ProjectFeedbackDialog = ({ open, onOpenChange, form, setForm, onSave }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>Overall Project Feedback</DialogTitle>
        <DialogDescription>
          Capture key project insights — all fields are optional
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Key Highlights / Achievements</Label>
          <Textarea
            value={form.key_achievements}
            onChange={(e) => setForm({ ...form, key_achievements: e.target.value })}
            placeholder="Main outcomes and achievements..."
            rows={3}
            data-testid="project-key-achievements-input"
          />
        </div>

        <div className="space-y-2">
          <Label>Challenges Faced</Label>
          <Textarea
            value={form.challenges_faced}
            onChange={(e) => setForm({ ...form, challenges_faced: e.target.value })}
            placeholder="Challenges encountered during delivery..."
            rows={2}
          />
        </div>

        <div className="space-y-2">
          <Label>Lessons Learned</Label>
          <Textarea
            value={form.lessons_learned}
            onChange={(e) => setForm({ ...form, lessons_learned: e.target.value })}
            placeholder="What would you do differently next time..."
            rows={2}
          />
        </div>

        <div className="space-y-2">
          <Label>Partner Feedback Summary <span className="text-muted-foreground font-normal text-xs">(Optional)</span></Label>
          <Textarea
            value={form.partner_feedback_summary}
            onChange={(e) => setForm({ ...form, partner_feedback_summary: e.target.value })}
            placeholder="Summary of feedback from the partner..."
            rows={2}
          />
        </div>

        <div className="space-y-2">
          <Label>Recommendations <span className="text-muted-foreground font-normal text-xs">(Optional)</span></Label>
          <Textarea
            value={form.recommendations}
            onChange={(e) => setForm({ ...form, recommendations: e.target.value })}
            placeholder="Recommendations for future training..."
            rows={2}
          />
        </div>

        <div className="space-y-2">
          <Label>MTM Feedback Score <span className="text-muted-foreground font-normal text-xs">(Optional, 0–5)</span></Label>
          <div className="relative max-w-[140px]">
            <Input
              type="number"
              min="0"
              max="5"
              step="0.1"
              value={form.mtm_feedback_score}
              onChange={(e) => setForm({ ...form, mtm_feedback_score: e.target.value })}
              placeholder="e.g. 4.5"
              data-testid="project-mtm-score-input"
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground pointer-events-none">/5</span>
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSave} className="bg-lime text-lime-foreground hover:bg-lime/90" data-testid="save-project-feedback-btn">
            Save Feedback
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default ProjectFeedbackDialog;
